import * as yup from '@if/core/yup'

export const failedVendorsFiltersSchema = yup.object({
  search: yup.text(),
  errorContains: yup.text(),
  minAttempts: yup.integer().min(1),
})

export type FailedVendorsFiltersType = yup.InferSubmit<typeof failedVendorsFiltersSchema>
